module.exports = __webpack_public_path__ + "static/kiteSketchThree-cc6c9839210a3f53977dff94a43ed88a.png";